/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host([disabled]) {
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--calcite-opacity-disabled);
}

:host([disabled]) *,
:host([disabled]) ::slotted(*) {
  pointer-events: none;
}

:host {
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-shrink: 0;
  flex-grow: 1;
  flex-direction: column;
  align-items: stretch;
  background-color: transparent;
  font-size: var(--calcite-font-size--1);
  line-height: 1rem;
  color: var(--calcite-color-text-2);
}
:host * {
  box-sizing: border-box;
}

:host([disabled]) ::slotted([calcite-hydrated][disabled]),
:host([disabled]) [calcite-hydrated][disabled] {
  /* prevent opacity stacking */
  opacity: 1;
}

.interaction-container {
  display: contents;
}

:host([filter-enabled]) header {
  margin-block-end: 0.25rem;
  display: flex;
  align-items: stretch;
  justify-content: flex-end;
  background-color: var(--calcite-color-foreground-1);
  --tw-shadow: 0 1px 0 var(--calcite-color-border-3);
  --tw-shadow-colored: 0 1px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
:host([filter-enabled]) header.sticky-pos {
  position: sticky;
  inset-block-start: 0px;
  z-index: var(--calcite-z-index);
}

calcite-filter {
  margin-block-end: 0px;
}

:host([loading][disabled]) {
  min-block-size: 2rem;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}